module.exports = __webpack_public_path__ + "img/badge-brown.94b4bb29.svg";